module.exports = __webpack_public_path__ + "logo_white.svg?c9c1a210de41a56477441f2251ef58ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_white.svg
// module id = 212
// module chunks = 0